"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
/* eslint-disable no-console */
var react_1 = (0, tslib_1.__importStar)(require("react"));
var styled_components_1 = (0, tslib_1.__importStar)(require("styled-components"));
var react_router_dom_1 = require("react-router-dom");
var okta_react_1 = require("@okta/okta-react");
var FosAuthorizer_1 = require("../../FosAuthorizer");
var config_1 = require("../../../config");
var login_bg_jpg_1 = (0, tslib_1.__importDefault)(require("../../../assets/login-bg.jpg"));
require("@okta/okta-signin-widget/dist/css/okta-sign-in.min.css");
var Login = function () {
    var defaultPath = (0, config_1.useNTConfig)().MicroFE.defaultPath;
    var _a = (0, okta_react_1.useOktaAuth)(), authStateManager = _a.oktaAuth.authStateManager, authState = _a.authState;
    var isAuthenticated = (authState !== null && authState !== void 0 ? authState : {}).isAuthenticated;
    var oktaWidgetConfig = FosAuthorizer_1.FosAuthorizer.oktaWidgetConfig, oktaWidget = FosAuthorizer_1.FosAuthorizer.oktaWidget;
    var widgetRef = (0, react_1.useRef)(oktaWidget);
    (0, react_1.useEffect)(function () {
        if (isAuthenticated === false) {
            oktaWidget
                .showSignInAndRedirect({
                el: widgetRef.current,
                scopes: oktaWidgetConfig === null || oktaWidgetConfig === void 0 ? void 0 : oktaWidgetConfig.authParams.scopes,
            })
                .catch(function (err) {
                // eslint-disable-next-line no-console
                console.log('An error occurred in the sign in widget');
                throw err;
            });
        }
    }, [isAuthenticated, oktaWidget, oktaWidgetConfig]);
    // handle successful SSO authentication with IDP
    (0, react_1.useEffect)(function () {
        var _a = oktaWidget.authClient, session = _a.session, token = _a.token, tokenManager = _a.tokenManager;
        var saveTokensFromFederation = function () { return (0, tslib_1.__awaiter)(void 0, void 0, void 0, function () {
            var sessionExists, response;
            return (0, tslib_1.__generator)(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, session.exists()];
                    case 1:
                        sessionExists = _a.sent();
                        if (!sessionExists) return [3 /*break*/, 3];
                        return [4 /*yield*/, token.getWithoutPrompt()];
                    case 2:
                        response = _a.sent();
                        tokenManager.setTokens(response.tokens);
                        authStateManager.updateAuthState();
                        _a.label = 3;
                    case 3: return [2 /*return*/];
                }
            });
        }); };
        saveTokensFromFederation();
    }, [oktaWidget, authStateManager]);
    return isAuthenticated ? (react_1.default.createElement(react_router_dom_1.Redirect, { to: defaultPath })) : (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(GlobalStyle, null),
        react_1.default.createElement(CenteredDiv, null,
            react_1.default.createElement(StyledOktaWidget, { ref: widgetRef }))));
};
exports.default = Login;
var GlobalStyle = (0, styled_components_1.createGlobalStyle)(templateObject_1 || (templateObject_1 = (0, tslib_1.__makeTemplateObject)(["\n  body {\n    background-image: url(", ");\n    height: 100%;\n    background-position: center;\n    background-repeat: no-repeat;\n    background-size: cover;\n  }\n"], ["\n  body {\n    background-image: url(", ");\n    height: 100%;\n    background-position: center;\n    background-repeat: no-repeat;\n    background-size: cover;\n  }\n"])), login_bg_jpg_1.default);
var CenteredDiv = styled_components_1.default.div(templateObject_2 || (templateObject_2 = (0, tslib_1.__makeTemplateObject)(["\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  min-height: 100vh;\n"], ["\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  min-height: 100vh;\n"])));
var StyledOktaWidget = styled_components_1.default.div(templateObject_3 || (templateObject_3 = (0, tslib_1.__makeTemplateObject)(["\n  #okta-sign-in.auth-container {\n    &.main-container {\n      font-family: ", ";\n    }\n\n    .okta-sign-in-header {\n      background-color: ", ";\n    }\n\n    .okta-form-title {\n      font-family: ", ";\n      font-size: 1.8rem;\n      line-height: 2.4rem;\n      padding-top: 1.5rem;\n      padding-bottom: 1.5rem;\n    }\n\n    .o-form-input {\n      padding-bottom: 1rem;\n    }\n\n    .button-primary {\n      background: ", ";\n\n      &:hover {\n        background: ", ";\n      }\n\n      &:active {\n        background: ", ";\n      }\n\n      &:disabled {\n        background: ", ";\n      }\n    }\n  }\n"], ["\n  #okta-sign-in.auth-container {\n    &.main-container {\n      font-family: ", ";\n    }\n\n    .okta-sign-in-header {\n      background-color: ", ";\n    }\n\n    .okta-form-title {\n      font-family: ", ";\n      font-size: 1.8rem;\n      line-height: 2.4rem;\n      padding-top: 1.5rem;\n      padding-bottom: 1.5rem;\n    }\n\n    .o-form-input {\n      padding-bottom: 1rem;\n    }\n\n    .button-primary {\n      background: ", ";\n\n      &:hover {\n        background: ", ";\n      }\n\n      &:active {\n        background: ", ";\n      }\n\n      &:disabled {\n        background: ", ";\n      }\n    }\n  }\n"])), function (_a) {
    var theme = _a.theme;
    return theme.fonts.robotoRegular;
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.NTWarmGrey[100];
}, function (_a) {
    var theme = _a.theme;
    return theme.fonts.robotoBold;
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.NTGreen[700];
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.NTGreen[600];
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.NTGreen[800];
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.NTGreen[500];
});
var templateObject_1, templateObject_2, templateObject_3;
